import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { STATUS } from './userDetailslice';
import { fetchDynamicUserDetailsAsync, fetchUserOnboardingFeildsAsync, updateDynamicUserDetailsAsync } from '../thunks/userOnboardThunk';
import { removeFaceAttributeFormpayloadJson, sortJsonObj } from '../../utils/DynamicUserOnboarding';
import { readFromLocalStorage } from '../../utils/DataEncryption';
interface FormData {
  [key: string]: any;
}

interface PayloadForUserRegistration {
  formData: FormData;
}
interface NewFormData {
  formSegments:any[];
}
interface NewPayloadForUserRegistration {
  appId:string;
  userType:string;
  formSegments: any[];
}



interface UserOnboardingState {
  userOnboardingJson: any | null;
  userOnboardingJsonStatus: string;
  status: string;
  error: string | null;
  payloadForUserRegistration: PayloadForUserRegistration;
  validationTempleteJson:  Record<string, any>;
  errorJson:Record<string, string>;
  newPayloadForUserRegistration:NewPayloadForUserRegistration;
  isEkycRequired: boolean;
  registerUserStatus: string;
  userDetailResponse:any | null;
  userDetailResponseWithFaceAttribute:any | null;
  userDetailResponseStatus: string;
  isBankDetailsRequired?: boolean;
  bankDetailsErrorMessage: string;
  userGetDetailsResponseStatus: string;
}

const initialState: UserOnboardingState = {
  userOnboardingJson: null,
  userOnboardingJsonStatus: STATUS.IDLE,
  status: STATUS.IDLE,
  error: null,
  payloadForUserRegistration: {
    formData: {},
  },
  newPayloadForUserRegistration: {
    appId:'',
    // userType: readFromLocalStorage("userType") ?? "Dealer",
    userType: "DEALER_EMPLOYEE",
    formSegments: [],
  },
  validationTempleteJson: {},
  errorJson: {},
  isEkycRequired: false,
  registerUserStatus: STATUS.IDLE,
  userDetailResponse: null,
  userDetailResponseWithFaceAttribute:null,
  userDetailResponseStatus: STATUS.IDLE,
  isBankDetailsRequired: false, // Default value, can be updated based on requirements
  bankDetailsErrorMessage: '',
  userGetDetailsResponseStatus: STATUS.IDLE,  
};

const userOnboardDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    userRegistrationPayload: (state, action: PayloadAction<{ key: string; value: any }>) => {
      const { key, value } = action.payload;
      // console.log("inside userRegistrationPayload",key,value)
      state.payloadForUserRegistration.formData[key] = value;
      // console.log("inside userRegistrationPayload",state.payloadForUserRegistration.formData)
    },
    clearUserRegistrationPayload: (state) => {
      state.payloadForUserRegistration.formData = {};
    },
    validationTemplatePayload: (state, action: PayloadAction<Record<string, any>>)  => {
     
      state.validationTempleteJson = {
        ...state.validationTempleteJson,
        ...action.payload, // Merge new validation JSON with the existing state
      };
    },
    clearValidationTemplatePayload: (state) => {
      state.payloadForUserRegistration.formData = {};
    },
    errorMessageJson: (state, action: PayloadAction<Record<string, any>>)  => {
     
      state.errorJson = {
        ...state.errorJson,
        ...action.payload, // Merge new validation JSON with the existing state
      };
     
    },
    clearErrorMessageJson: (state) => {
      state.payloadForUserRegistration.formData = {};
    },

    reSetUserRegistrationPayload: (state) => {
      state.payloadForUserRegistration.formData = {};
    },

    userRegistrationNewPayload: (state, action: PayloadAction<{ segment: any }>) => {
      if (!state.newPayloadForUserRegistration.formSegments) {
        state.newPayloadForUserRegistration.formSegments = [];
      }
      state.newPayloadForUserRegistration.appId = readFromLocalStorage("appId");
      const newSegment = action.payload.segment;

      const existingIndex = state.newPayloadForUserRegistration.formSegments.findIndex(
        (segment) => segment.segmentId === newSegment.segmentId
      );

      if (existingIndex !== -1) {
        // 🔁 Update existing segment
        state.newPayloadForUserRegistration.formSegments[existingIndex] = newSegment;
      } else {
        // ➕ Push new segment
        state.newPayloadForUserRegistration.formSegments.push(newSegment);
      }
    },

    resetUserRegistrationNewpayload: (state) => {
      state.newPayloadForUserRegistration = {
        appId:'',
        // userType: readFromLocalStorage("userType") ?? "Dealer",
        userType: "DEALER_EMPLOYEE",
        formSegments: [],
      }
    }
  },


  extraReducers: (builder) => {
    builder
      .addCase(fetchUserOnboardingFeildsAsync.pending, (state) => {
        state.status = STATUS.LOADING;
      })
      .addCase(fetchUserOnboardingFeildsAsync.fulfilled, (state, action) => {
        const sortedJsonObj = sortJsonObj(action.payload?.applicationFormDetails?.formSegments);
        state.isEkycRequired = action.payload?.applicationFormDetails?.isKycEnabled;
        state.userOnboardingJson = sortedJsonObj;
        state.userOnboardingJsonStatus = STATUS.SUCCESS;
        state.status = STATUS.SUCCESS;
      })
      .addCase(fetchUserOnboardingFeildsAsync.rejected, (state, action) => {
        state.status = STATUS.FAILED;
        state.error = action.error?.message || 'Failed to fetch data';
      })


      .addCase(fetchDynamicUserDetailsAsync.pending, (state) => {
        state.status = STATUS.LOADING;
        state.userGetDetailsResponseStatus = STATUS.LOADING;
      })
      .addCase(fetchDynamicUserDetailsAsync.fulfilled, (state, action) => {
        // const sortedJsonObj = sortJsonObj(action.payload);
        console.log("action.payload",action.payload);
        state.isEkycRequired = action.payload?.applicationFormDetails?.isKycEnabled;
        state.isBankDetailsRequired = action.payload?.bankDetailsMandatory;
        const sortedJsonObj = removeFaceAttributeFormpayloadJson(action.payload);
        state.userDetailResponse = sortedJsonObj;
        state.userDetailResponseWithFaceAttribute = action.payload;
        state.status = STATUS.SUCCESS;
        state.userGetDetailsResponseStatus = STATUS.SUCCESS;
      })
      .addCase(fetchDynamicUserDetailsAsync.rejected, (state, action) => {
        state.status = STATUS.FAILED;
        state.userGetDetailsResponseStatus = STATUS.FAILED;
        state.bankDetailsErrorMessage = action.error?.message || 'Failed to fetch data';
      })
      .addCase(updateDynamicUserDetailsAsync.pending, (state) => {
        state.userDetailResponseStatus = STATUS.LOADING;
      })
      .addCase(updateDynamicUserDetailsAsync.fulfilled, (state, action) => {
        state.userDetailResponseStatus = STATUS.SUCCESS;
      })
      .addCase(updateDynamicUserDetailsAsync.rejected, (state, action) => {
        state.userDetailResponseStatus = STATUS.FAILED;
      })
  },
});


export const { userRegistrationPayload,userRegistrationNewPayload,reSetUserRegistrationPayload, clearUserRegistrationPayload,validationTemplatePayload,errorMessageJson,resetUserRegistrationNewpayload,clearValidationTemplatePayload,clearErrorMessageJson } = userOnboardDetailsSlice.actions;
export default userOnboardDetailsSlice.reducer;


